module.exports = __webpack_public_path__ + "static/media/cloud1.ae9ba067.svg";